import React from 'react'
import { Box, CircularProgress, Typography } from '@mui/material'

export default function GoogleOAuthCallback() {
  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      minHeight="100vh"
      bgcolor="background.default"
    >
      <CircularProgress size={60} />
      <Typography variant="h6" sx={{ mt: 3, color: 'text.secondary' }}>
        Completing Google Sign In...
      </Typography>
      <Typography variant="body2" sx={{ mt: 1, color: 'text.secondary' }}>
        Please wait while we authenticate your account
      </Typography>
    </Box>
  )
} 